import { upload } from "@/api/http";
import { Quill } from "vue-quill-editor";
import { ElNotification } from "element-ui";
class CustomImageUpload {
  constructor(quill, options) {
    console.log(`quill`, quill);
    console.log(`options`, options);
    this.quill = quill;
    this.options = options;
    this.handleImageUpload = this.handleImageUpload.bind(this);
    quill.getModule("toolbar").addHandler("image", this.handleImageUpload);
    console.log("执行.....");
  }

  handleImageUpload() {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.setAttribute("multiple", true); // 这里设置多选
    input.click();

    input.onchange = () => {
      console.log(this.options);
      
      this.options.onUploadStart();
      const files = (Array.from(input.files) || []).filter((file) => {
        if (/^image\//.test(file.type)) {
          return file;
        } else {
          setTimeout(() => {
            ElNotification.error({
              title: `${file.name}文件格式不正确，只能上传图片`,
              customClass: "ApiMessage upload-error",
            });
          }, 100);
        }
      });
      const promise_all = (files || []).map((file) => this.uploadImage(file));
      Promise.all(promise_all)
        .then((res) => {
          console.log(res);
        })
        .finally(() => {
          this.options.onUploadEnd();
        });
    };
  }

  uploadImage(file) {
    return new Promise((resolve, reject) => {
      // 这里进行图片上传的逻辑
      const formData = new FormData();
      formData.append("file", file);
      upload("ec/uploadeducationcontentvideo", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          if (!res) return;
          const { data } = res;
          console.log(res,'res');
          
          const range = this.quill.getSelection(true);
          this.quill.insertEmbed(range.index, "image", data); // 假设服务器返回的是图片的URL
          this.quill.setSelection(range.index + 1, Quill.sources.SILENT);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
export default CustomImageUpload;
